import { useMemo } from 'react'

import { useDimensions } from '@/src/general/hooks/useDimensions'

export const useLimitItem = () => {
  const { xm, xs, sm, lg, md } = useDimensions()

  const limit = useMemo(() => {
    if (sm || xs || xm) return 6
    if (md) return 9
    if (lg) return 10
    return 10
  }, [xm, xs, sm, lg, md])

  return { limit }
}
